import { render } from "./AtributoSubModal.vue?vue&type=template&id=c0182b06"
import script from "./AtributoSubModal.vue?vue&type=script&lang=js"
export * from "./AtributoSubModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__